const getSelectedBabyId = state => state.ui.selectedBabyId;
const getEditBabyId = state => state.ui.editBabyId;

const getLogoutWarningModalShown = state => state.ui.logoutWarningModalShown;

export { getSelectedBabyId, getEditBabyId, getLogoutWarningModalShown };
